module.exports = {
	// ApiUrl: "http://localhost:20002",
	// ApiFren : "http://192.168.1.51:8088",
	// PayFren : "http://192.168.1.51:3001",

	ApiUrl: "https://sunrise.payfren.id",
	ApiFren: "https://rainbow.payfren.id",
	PayFren: "https://payfren.id",
	Resource: "https://resource.payfren.id/",
}
